import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

export const FeatureWrapper = styled.div`
&:not(:first-child) {
    margin-top: 24px;
}
`;

export const CategoryWrapper = styled.div`
    margin-bottom: 12px;
    > label:first-child {
        margin-right: 4px;
    }
`;

export const TitleContainer = styled.div`
    height: 48px;
    display: flex;
    align-items: center;
`;

interface TitleWrapperProps {
    isFirst: boolean;
}

export const TitleWrapper = styled.div<TitleWrapperProps>`
    width: 100%;
    height: inherit;
    padding: 12px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${props => props.isFirst ? null : css`border-top: 1px solid ${palette('gray_opacity_100')};`}
`;

export const IconImageWrapper = styled.div`
    width: 24px;
    height: 24px;
    margin-right: 12px;
`;

export const TagWrapper = styled.div`
    border-radius: 10px;
    background-color: ${palette('blue_opacity_100')};
    height: 24px;
    padding: 2.5px 8px;
    display: flex;
`;